import React, { FC, useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../../../../../store';
import { IClub } from '../../../../../store/player/clubs/store';

import InvitationBanner from './Components/InvitationBanner/InvitationBanner';
import { InvitationsStyled } from './Invitations.Styles';

const Invitations: FC = () => {
  const { clubs } = useContext(GlobalContext);

  const [clubsWithInvitations, setClubsWithInvitations] = useState<IClub[]>([]);

  useEffect(() => {
    setClubsWithInvitations(
      Object.values(clubs.all).filter((club: IClub) => club.status === 'invited')
    );
  }, [clubs]);

  return (
    <>
      {clubsWithInvitations.map(club => (
        <InvitationsStyled>
          <InvitationBanner
            id={club.id}
            key={`InvitationBanner-${club.id}`}
            name={club.name}
            image={club.profileImage}
          />
        </InvitationsStyled>
      ))}
    </>
  );
};

export default Invitations;
